var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Notifications'),_c('TheNotifications'),_c('router-view'),(_vm.sessionWarningVisible)?_c('SessionInactivityModal',{attrs:{"active":_vm.sessionWarningVisible},on:{"continue-session":_vm.continueSession,"close-session":_vm.doLogout,"countdown-finished":_vm.doLogout}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }